const urlconfig = (passkey = 'dev') => {
  const config = {

  dev: {
    apiurl: 'http://localhost:5000',
    authUrl: 'http://localhost:3000'
  },
  test: {
    apiurl: 'https://uat-api-mp.idfreshfood.com',
    authUrl: 'https://testmonthplanner.intranet.idfreshfood.com'
  },
  uat: {
    apiurl: 'https://test-api-mp.idfreshfood.com',
    authUrl: 'https://uat.intranet.idfreshfood.com'
  },
  live: {
   apiurl: 'https://live-api-mp.idfreshfood.com',
    authUrl: 'https://monthplanner.intranet.idfreshfood.com'
  }
};
return config[passkey] || config['dev'];
};


export default urlconfig;